import DispensaryCategoryPage from 'src/dispensary/category';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';

DispensaryCategoryPage.layout = MainDispensaryLayout;
export default DispensaryCategoryPage;
